var CasePracticeCommunicateComponent = (function () {
    function CasePracticeCommunicateComponent() {
    }
    CasePracticeCommunicateComponent.prototype.ngOnInit = function () {
    };
    return CasePracticeCommunicateComponent;
}());
export { CasePracticeCommunicateComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-communicate/case-practice-communicate.component.ts.pre-build-optimizer.js